import { MP_LEVELS } from '../../../../../consts/index.js';
import { ActivitySummary } from './ActivitySummary.jsx';
import { FlightSummary } from './FlightSummary.jsx';
import { MediaPlanSummary } from './MediaPlanSummary.jsx';

const mapLevelToLevelInfo = {
  [MP_LEVELS.MEDIA_PLAN]: MediaPlanSummary,
  [MP_LEVELS.ACTIVITY]: ActivitySummary,
  [MP_LEVELS.FLIGHT]: FlightSummary,
};

export const SummaryFactory = ({
  level,
}: {
  level: keyof typeof mapLevelToLevelInfo;
}) => {
  const LevelInfoComponent = mapLevelToLevelInfo[level];

  return <LevelInfoComponent />;
};
